import { useGT, useLocale } from 'gt-react';
import { formatDatetimeWithSeconds } from 'src/utils/dateUtils';
import { compactRunTimeRange, runDurationParts } from './runTimingFormat';

export function TaskRunTiming({
  startedAt,
  completedAt,
}: {
  startedAt: Date | null;
  completedAt: Date | null;
}) {
  const gt = useGT();
  if (!startedAt) return null;
  const start = formatDatetimeWithSeconds(startedAt);
  const exact = completedAt
    ? gt('{start} to {end}', {
        context: 'recorded agent run time range',
        start,
        end: formatDatetimeWithSeconds(completedAt),
      })
    : gt('Started {start}', {
        context: 'recorded agent run start time',
        start,
      });
  return (
    <span
      className="text-xs text-muted-foreground"
      title={exact}
      aria-label={exact}
    >
      {completedAt ? (
        <CompletedTiming start={startedAt} end={completedAt} />
      ) : (
        gt('Started {start}', {
          context: 'recorded agent run start time',
          start,
        })
      )}
    </span>
  );
}

function CompletedTiming({ start, end }: { start: Date; end: Date }) {
  const gt = useGT();
  const locale = useLocale();
  const duration = runDurationParts(start, end);
  const range = compactRunTimeRange(start, end, { locale });
  if (!duration) return range;
  const elapsed =
    duration.hours !== '0'
      ? gt('{hours}h {minutes}m {seconds}s', {
          context: 'compact agent run duration',
          ...duration,
        })
      : gt('{minutes}m {seconds}s', {
          context: 'compact agent run duration',
          ...duration,
        });
  return (
    <>
      {gt('{duration} · {range}', {
        context: 'compact run duration and local time range',
        duration: elapsed,
        range,
      })}
    </>
  );
}
